// src/components/DataTablePage.jsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import './DataTablePage.css';

function DataTablePage() {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, 'submissions'));
      const dataList = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setData(dataList);
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'submissions', id));
      setData((prevData) => prevData.filter((entry) => entry.id !== id));

      // Show success notification
      setNotification({ show: true, message: 'Document deleted successfully', type: 'success' });

      // Hide the notification after 3 seconds
      setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
    } catch (error) {
      console.error('Error deleting document:', error);

      // Show error notification
      setNotification({ show: true, message: 'Failed to delete document', type: 'error' });

      // Hide the notification after 3 seconds
      setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
    }
  };

  return (
    <div className="table-container">
      <h2>Respostas dos usuários</h2>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Idade</th>
            <th>WhatsApp</th>
            <th>Email</th>
            <th>Tipo Pessoa</th>
            <th>Organização</th>
            <th>Modelo</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry) => (
            <tr key={entry.id}>
              <td>{entry.nome}</td>
              <td>{entry.idade}</td>
              <td>{entry.whatsapp}</td>
              <td>{entry.email}</td>
              <td>{entry.tipoPessoa}</td>
              <td>{entry.orgaoNome || 'N/A'}</td>
              <td>{entry.selectedImage}</td>
              <td>
                <button onClick={() => handleDelete(entry.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Custom Notification */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
    </div>
  );
}

export default DataTablePage;
